import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPremiumIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10ZM12.7333 8.49998C12.675 8.54165 12.5833 8.52498 12.5417 8.46665L10.2167 4.72498C10.1167 4.56665 9.88333 4.56665 9.78333 4.72498L7.45833 8.46665C7.41667 8.53332 7.33333 8.54998 7.26667 8.49998L3.95 6.11665C3.85833 6.05832 3.73333 6.13332 3.75 6.24165L4.7 12.5833C4.73333 12.8416 4.95833 13.0333 5.21666 13.0333H14.7833C15.0417 13.0333 15.2667 12.8416 15.3 12.5833L16.25 6.24165C16.2667 6.13332 16.1417 6.04998 16.05 6.11665L12.7333 8.49998ZM14.6333 14.0833H5.53332C5.16973 14.0833 4.87499 14.3762 4.87499 14.7375C4.87499 15.0988 5.16973 15.3917 5.53332 15.3917H14.6333C14.9969 15.3917 15.2917 15.0988 15.2917 14.7375C15.2917 14.3762 14.9969 14.0833 14.6333 14.0833Z",
		fill: "#202020"
	})
});
export default SvgPremiumIcon;
